import { captureException } from '@sentry/nextjs';
import { TGetPropertyResponse } from './get-property.types';

export type TGetPropertyProps = {
    propertyId: number;
    baseUrl: string;
    cookies?: string;
};

export const getPropertyUrl = '/property-api/v1/property/:propertyId';

export async function getProperty({
    propertyId,
    baseUrl,
    cookies,
}: TGetPropertyProps): Promise<TGetPropertyResponse> {
    const url = new URL(getPropertyUrl, baseUrl);

    const headers: Record<string, string> = {
        'Content-Type': 'application/json',
    };

    if (cookies) {
        headers['Cookie'] = cookies;
    }

    const response = await fetch(
        url.href.replace(':propertyId', propertyId.toString()),
        {
            method: 'GET',
            headers,
            credentials: 'include',
        }
    );

    if (!response.ok) {
        const error = new Error(`Failed to get property ${propertyId}`);

        captureException(error);

        throw error;
    }

    let data: TGetPropertyResponse;

    try {
        data = await response.json();
    } catch (error) {
        const outerError = new Error(
            `Failed to parse response from get property ${propertyId}`
        );

        captureException(outerError, { extra: { innerError: error } });

        throw outerError;
    }

    return data;
}
